<textarea
  class="form-control"
  #textArea
  [ngStyle]="styles"
  [placeholder]="placeholder"
  [maxlength]="maxLength"
  [rows]="rows"
  [attr.name]="placeholder"
  [disabled]="disabled"
  (input)="blockEmoji(textArea.value)"
  [(ngModel)]="model">
</textarea>
